import { makeVar, useReactiveVar } from '@apollo/client'

const refusedEntryResetsVar = makeVar<Partial<Record<string, number>>>({})

/** Remounts the entry's card, so inputs that keep their own copy of the text show the saved one again. */
export const resetRefusedEntry = (entryId: string) => {
  const resets = refusedEntryResetsVar()
  refusedEntryResetsVar({ ...resets, [entryId]: (resets[entryId] ?? 0) + 1 })
}

export const useRefusedEntryResets = (entryId: string) =>
  useReactiveVar(refusedEntryResetsVar)[entryId] ?? 0
